module.exports = __webpack_public_path__ + "img/Tgi_fridays_logo.591eef1c.svg";